module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/home/sections/apps/assets/device_icon-08467c8431a729df6b1a3b9c399301bd.svg";